import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { formatNumber } from "../../../utils/helpers";

class Despachados extends Component {
    state = {
        programacion: {},
        tarjetas: [],
    };
    componentDidMount() {
        this.getProgramacion();
    }
    getProgramacion = async () => {
        const id = this.props.match.params.id;
        const response = await this.props.request("programaciones/" + id);

        if (response.success) {
            this.setState({
                programacion: {
                    id: response.data.id,
                    nombre: response.data.nombre,
                    fecha: response.data.fecha,
                },
                tarjetas: response.data.tarjetas,
            });
            window.print();
        }
    };
    render() {
        const { programacion, tarjetas } = this.state;
        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>
                        Programación {programacion.nombre}
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {new Date().toLocaleString()}
                    </div>
                    <div className='col-md-12 text-center p-b-10'></div>
                </div>
                <table className='table'>
                    <thead>
                        <tr>
                            <th style={{ width: "150px" }}>Ficha</th>
                            <th
                                style={{
                                    width: "550px",
                                }}>
                                Chofer/Ruta
                            </th>
                            <th>Operadores</th>
                            <th className='text-right'>Meta</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tarjetas.map((tarjeta) => {
                            const chofer = tarjeta.operadores.filter(
                                (op) =>
                                    op.nombre &&
                                    op.nombre.toLowerCase() === "chofer"
                            )[0];
                            const ayudantes = tarjeta.operadores
                                .filter(
                                    (op) =>
                                        op.nombre &&
                                        op.nombre.toLowerCase() !== "chofer" &&
                                        op.asignadoNombre
                                )
                                .map((op) => op.asignadoNombre);
                            return (
                                <tr key={tarjeta.ficha}>
                                    <td>
                                        {tarjeta.ficha}
                                        <div>
                                            <small class="categoria-camion">
                                                {tarjeta.categoria.toUpperCase()}
                                            </small>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>
                                            {chofer.asignadoNombre} - CEL:{" "}
                                            {chofer.asignadoTelefono}
                                        </strong>
                                        <div>
                                            <small>
                                                <strong>
                                                    {tarjeta.ruta &&
                                                        tarjeta.ruta.nombre}
                                                </strong>{" "}
                                                (
                                                {tarjeta.ruta &&
                                                    tarjeta.ruta.descripcion}
                                                )
                                            </small>
                                        </div>
                                        {tarjeta.nota && (
                                            <small>
                                                <strong>Nota:</strong>{" "}
                                                {tarjeta.nota}
                                            </small>
                                        )}
                                    </td>
                                    <td style={{ fontSize: "14px" }}>
                                        <div></div>
                                        {ayudantes.map((op) => (
                                            <div>{op}</div>
                                        ))}
                                    </td>
                                    <td className='text-right'>
                                        {formatNumber(
                                            tarjeta.meta > 1000
                                                ? tarjeta.meta / 1000
                                                : tarjeta.meta
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(withRequest(Despachados));
